/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.DataTable').directive('accSortableColumn', [
    function () {
        return {
            scope: true,
            transclude: true,
            template: function (_, attrs) {
                return (
                    '<span class="sort-label" ng-transclude></span><i ng-show="sorting.getColumn() == \'' +
                    attrs['accSortableColumn'] +
                    "'\" ng-class=\"{true: 'icon-sort-up', false: 'icon-sort-down'}[sorting.isAsc()]\"></i>"
                );
            },
            link: function (scope, element, attrs) {
                element.addClass('sortable-column');
                element.on('click', function () {
                    scope.sortColumn(attrs['accSortableColumn'], attrs['defaultSortingDirection']);
                });
            }
        };
    }
]);
